import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ProductSetType } from '@econtractor/types';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import SpinnerBlock from 'components/others/SpinnerBlock';
import TableHeadTdOrder from 'components/others/TableHeadTdOrder';
import { useProductSet } from './context/ProductSetProvider';
import SetTableBody from './SetTableBody';

interface SetsTableProps {
    setsList: ProductSetType[];
    fetchSets: (force?: boolean) => Promise<void>;
    setEditSetId: (setId: number) => void;
}

const SetsTable = ({ setsList, fetchSets, setEditSetId }: SetsTableProps) => {
    const { t } = useTranslation(['Sets']);
    const { auth } = useAuth();
    const { showSpinner, setsOrder, setSetsOrder, setsDesc, setSetsDesc } = useProductSet();

    const handleOrderClick = (value: string, desc: boolean) => {
        setSetsOrder(value);
        setSetsDesc(desc);
    };

    return (
        <>
            <SpinnerBlock onlyBlur={true} show={showSpinner} />

            <div className="crm-table-wrap">
                <Table className="SetsTable table-hover">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-name">
                                <TableHeadTdOrder
                                    title={t('fields.set')}
                                    onClick={handleOrderClick}
                                    value={setsOrder}
                                    desc={setsDesc}
                                    fieldName="set_name"
                                />
                            </td>

                            <td className="head-vendor">
                                <TableHeadTdOrder
                                    title={t('fields.category')}
                                    onClick={handleOrderClick}
                                    value={setsOrder}
                                    desc={setsDesc}
                                    fieldName="category_name"
                                />
                            </td>

                            <td className="head-id">
                                <TableHeadTdOrder
                                    title={t('fields.id')}
                                    onClick={handleOrderClick}
                                    value={setsOrder}
                                    desc={setsDesc}
                                    fieldName="ID"
                                />
                            </td>

                            <td className="head-article">
                                <TableHeadTdOrder
                                    title={t('fields.article')}
                                    onClick={handleOrderClick}
                                    value={setsOrder}
                                    desc={setsDesc}
                                    fieldName="set_article"
                                />
                            </td>

                            <td className="head-price">{t('fields.priceList')}</td>

                            <td className="head-updated">
                                <TableHeadTdOrder
                                    title={t('fields.updated')}
                                    onClick={handleOrderClick}
                                    value={setsOrder}
                                    desc={setsDesc}
                                    fieldName="set_updated"
                                />
                            </td>

                            {hasUserAccess(auth?.user, 'prodEdit') && <td className="head-action">{t('fields.action')}</td>}
                        </tr>
                    </thead>

                    <SetTableBody setsList={setsList} fetchSets={fetchSets} setEditSetId={setEditSetId} />
                </Table>
            </div>
        </>
    );
};

export default SetsTable;
